export const queries = {
  OWNED_NFTS: 'OWNED_NFTS',
  OWNED_NFT: 'OWNED_NFT',
}
